import styled from 'styled-components';
import { colors } from '../../colors';
import { fonts, fontsArabic } from '../../fonts';
import { BrandButtonProps, ButtonTypes } from './brand-button';
const BACKGROUND_COLOR_MAP: { [buttonType in ButtonTypes]: string } = {
  primary: colors.green,
  secondary: '#1A1A1A',
  ghost: 'transparent',
  empty: '#6DCC73',
};

const FONT_COLOR_MAP: { [buttonType in ButtonTypes]: string } = {
  primary: colors.black,
  secondary: colors.white,
  ghost: colors.black,
  empty: colors.black,
};

export const Layer = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  background-color: ${BACKGROUND_COLOR_MAP['empty']};
  opacity: 0.9;
`;

export const Button = styled.a<BrandButtonProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: ${(props) =>
    props.showIcon === false ? 'space-between' : ''};
  padding: ${(props) => (props.showIcon === false ? '5px 0px' : '12px 15px')};
  padding-inline-start: ${(props) => (props.showIcon === false ? '14px' : '')};
  padding-top: ${({ theme }) => (theme.rtl ? '10px' : '')};
  opacity: ${(props) => (props.type === 'empty' ? 0.98 : 1)};
  border: ${({ type }) =>
    type === 'empty' ? 'solid 1px transparent' : `solid 1px ${colors.black};`};
  &:hover {
    color: ${({ type }) => FONT_COLOR_MAP?.[type ?? 'primary']};
  }
  box-shadow: ${({ type }) =>
    type === 'ghost' || type === 'empty'
      ? 'none'
      : `2px 2px 0px ${colors.black};`};
  border-radius: 3px;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ type }) => FONT_COLOR_MAP?.[type ?? 'primary']};
  background-color: ${({ type }) => BACKGROUND_COLOR_MAP?.[type ?? 'primary']};
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const Label = styled.span`
  background-color: ${colors.yellow};
  border: 1px solid #000000;
  height: 27px;
  border-radius: 8px;
  font-family:'Dm Sans';
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 10px;
  color: #1a1a1a;
  text-align: center;
  padding: 0px 12px;
  margin-inline-end: 15px;
`;

export const Icon = styled.img<{ removeBackGround: boolean }>`
  background: ${(props) =>
    props.removeBackGround ? 'transparent' : '#1a1a1a'};
  border-radius: 60.1667px;
  padding: 4.5px;
  width: 22px;
  height: 22px;
  transform: ${({ theme }) => (theme.rtl ? 'rotate(180deg)' : '')};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;
